import React, { useState } from 'react';
import PillIcon from './PillIcon';

const LanguageSelector = ({ language, setLanguage, theme, setTheme, swapOrder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { value: 'en', label: 'English', short: 'EN' },
    { value: 'ru', label: 'Русский', short: 'RU' },
    { value: 'zh', label: '中文', short: 'ZH' },
    { value: 'sv', label: 'Svenska', short: 'SV' },
  ];

  const handleLanguageChange = (value) => {
    setLanguage(value);
    setIsOpen(false);
  };

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const LanguageSwitcher = (
    <>
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        className="selector-button"
        style={{ fontWeight: 'bold' }}
      >
        {languages.find(lang => lang.value === language)?.short || '??'}
      </button>
      <div className={`dropdown ${isOpen ? 'open' : ''}`}>
        {languages.map((lang) => (
          <div
            key={lang.value}
            className="dropdown-option"
            style={{ fontWeight: 'bold' }}
            onClick={() => handleLanguageChange(lang.value)}
          >
            {lang.label}
          </div>
        ))}
      </div>
    </>
  );

  const ThemeSwitcher = (
    <button onClick={toggleTheme} className="theme-toggle">
      <PillIcon theme={theme} />
    </button>
  );

  return (
    <div className="selector-container">
      {swapOrder ? ThemeSwitcher : LanguageSwitcher}
      {swapOrder ? LanguageSwitcher : ThemeSwitcher}
    </div>
  );
};

export default LanguageSelector;
